import { render, staticRenderFns } from "./chuku.vue?vue&type=template&id=07beb902"
import script from "./chuku.vue?vue&type=script&lang=js"
export * from "./chuku.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports